import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Export() {
  const { apiFetch, token } = useAuth();
  const [fiscalYears, setFiscalYears] = useState([]);
  const [selectedFy, setSelectedFy] = useState('');
  const [exporting, setExporting] = useState('');
  const [error, setError] = useState('');

  const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';

  useEffect(() => {
    apiFetch('/api/settings/fiscal-years').then(fy => {
      setFiscalYears(fy);
      const active = fy.find(f => f.is_active);
      if (active) setSelectedFy(String(active.id));
    }).catch(err => setError(err.message));
  }, []);

  const downloadFile = async (url, filename) => {
    try {
      const resp = await fetch(`${API_BASE}${url}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!resp.ok) {
        const err = await resp.json();
        throw new Error(err.error || 'Download fejlede');
      }
      const blob = await resp.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename || 'export';
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (err) {
      alert(err.message);
    }
  };

  const handleSaftExport = async () => {
    setExporting('saft');
    await downloadFile(
      `/api/export/saf-t?fiscal_year_id=${selectedFy}`,
      `SAF-T_${selectedFy}.xml`
    );
    setExporting('');
  };

  const handleBackup = async () => {
    setExporting('backup');
    await downloadFile('/api/export/backup', 'backup.json');
    setExporting('');
  };

  return (
    <div>
      <div className="page-header">
        <h1>Eksport</h1>
      </div>

      <div className="card">
        <h3 style={{marginBottom: '1rem'}}>SAF-T DK Eksport</h3>
        <p style={{fontSize: '0.875rem', color: 'var(--gray-700)', marginBottom: '1rem'}}>
          Eksporter regnskabsdata i SAF-T DK format (Standard Audit File for Tax).
          Dette er påkrævet af Erhvervsstyrelsen og bruges til revision og myndighedsindberetning.
        </p>
        <div className="form-row" style={{alignItems: 'flex-end'}}>
          <div className="form-group">
            <label>Regnskabsår</label>
            <select className="form-control" value={selectedFy} onChange={e => setSelectedFy(e.target.value)}>
              <option value="">Vælg regnskabsår</option>
              {fiscalYears.map(fy => (
                <option key={fy.id} value={fy.id}>{fy.name} {fy.is_active ? '(Aktiv)' : fy.is_closed ? '(Lukket)' : ''}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <button className="btn btn-primary" onClick={handleSaftExport}
              disabled={!selectedFy || exporting === 'saft'}>
              {exporting === 'saft' ? 'Eksporterer...' : 'Download SAF-T XML'}
            </button>
          </div>
        </div>
      </div>

      <div className="card" style={{marginTop: '1rem'}}>
        <h3 style={{marginBottom: '1rem'}}>Fuld backup</h3>
        <p style={{fontSize: '0.875rem', color: 'var(--gray-700)', marginBottom: '1rem'}}>
          Download en komplet backup af alle regnskabsdata (kontoplan, bilag, medlemmer, fakturaer, indstillinger).
          Backup gemmes som JSON-fil og kan bruges til gendannelse eller arkivering.
        </p>
        <div style={{background: '#eff6ff', border: '1px solid #93c5fd', borderRadius: '8px', padding: '0.85rem', marginBottom: '1rem'}}>
          <strong style={{color: '#1d4ed8'}}>Bogføringsloven kræver 5 års opbevaring</strong>
          <p style={{fontSize: '0.85rem', color: '#1e40af', margin: '0.25rem 0 0 0'}}>
            Gem regelmæssige backups på et sikkert sted. Alle bilag og posteringer skal opbevares i mindst 5 år.
          </p>
        </div>
        <button className="btn btn-primary" onClick={handleBackup} disabled={exporting === 'backup'}>
          {exporting === 'backup' ? 'Eksporterer...' : 'Download fuld backup (JSON)'}
        </button>
      </div>
    </div>
  );
}
